import { Action } from "types/interface"

export interface CaptchaState {
  captcha_loading: boolean,
}

const defaultState: CaptchaState = {
  'captcha_loading': false,
}

export default (state = defaultState, action: Action) => {
  const {type, value} = action
  const old_value = state[type]

  if (old_value !== undefined) {
    return {
      ...state,
      [type]: value
    }
  }
  return state
}
